import { logout } from '../../api/auth.api';
import { authStorage } from '../../auth/auth-storage';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { clearSession } from '../../store/authSlice';

interface HeaderProps {
  isMenuOpen: boolean;
  onMenuOpen: () => void;
}

export function Header({ isMenuOpen, onMenuOpen }: HeaderProps) {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.auth.user);
  const displayName = user
    ? [user.firstName, user.lastName].filter(Boolean).join(' ') || user.email
    : 'Guest';

  const handleLogout = async () => {
    const refreshToken = authStorage.getRefreshToken();
    try {
      if (refreshToken) await logout(refreshToken);
    } catch {
      // The local session is cleared even when the server session is already invalid.
    } finally {
      authStorage.clear();
      dispatch(clearSession());
    }
  };

  return (
    <header className="app-header">
      <div className="header-title">
        <button
          aria-controls="main-navigation"
          aria-expanded={isMenuOpen}
          aria-label="Open navigation menu"
          className="mobile-menu-button"
          type="button"
          onClick={onMenuOpen}
        >
          <svg aria-hidden="true" viewBox="0 0 24 24">
            <path d="M4 7h16M4 12h16M4 17h16" />
          </svg>
        </button>
        <div>
        <p className="eyebrow">Inventory ERP</p>
        <h1>Commercial management</h1>
        </div>
      </div>
      <div className="header-actions">
        <span className="user-pill">{displayName}</span>
        {user && <button className="button button--ghost" type="button" onClick={() => void handleLogout()}>Sign out</button>}
      </div>
    </header>
  );
}
